// Unified Industry Categories for GCC Construction, Infrastructure & Energy
// Used across News, Projects, and Companies pages

export const STANDARD_INDUSTRIES = [
  // Construction
  { id: 'general_construction', en: 'General Construction', ar: 'البناء العام', category: 'Construction' },
  { id: 'civil', en: 'Civil Works', ar: 'الأعمال المدنية', category: 'Construction' },
  { id: 'mep', en: 'MEP (Mechanical, Electrical, Plumbing)', ar: 'الميكانيكية والكهربائية والسباكة', category: 'Construction' },
  { id: 'fit_out', en: 'Fit-out & Interior', ar: 'التشطيبات الداخلية', category: 'Construction' },
  
  // Real Estate
  { id: 'mixed_use', en: 'Mixed Use Real Estate Development', ar: 'التطوير العقاري متعدد الاستخدامات', category: 'Real Estate' },
  { id: 'commercial', en: 'Commercial Real Estate Development', ar: 'التطوير العقاري التجاري', category: 'Real Estate' },
  { id: 'residential', en: 'Residential Real Estate Development', ar: 'التطوير العقاري السكني', category: 'Real Estate' },
  
  // Infrastructures
  { id: 'utilities_infra', en: 'Utilities Infrastructure', ar: 'البنية التحتية للمرافق', category: 'Infrastructures' },
  { id: 'transportation', en: 'Transportation', ar: 'النقل', category: 'Infrastructures' },
  { id: 'airports', en: 'Airports', ar: 'المطارات', category: 'Infrastructures', parent: 'transportation' },
  { id: 'maritime', en: 'Maritime & Ports', ar: 'الموانئ والملاحة', category: 'Infrastructures', parent: 'transportation' },
  { id: 'logistics', en: 'Logistics', ar: 'الخدمات اللوجستية', category: 'Infrastructures' },
  { id: 'datacenters', en: 'Data Centers', ar: 'مراكز البيانات', category: 'Infrastructures' },
  
  // Energy & Utilities
  { id: 'oil_gas', en: 'Oil & Gas', ar: 'النفط والغاز', category: 'Energy & Utilities' },
  { id: 'renewable', en: 'Renewable Energy', ar: 'الطاقة المتجددة', category: 'Energy & Utilities' },
  { id: 'power', en: 'Power Generation, Transmission & Distribution', ar: 'توليد ونقل وتوزيع الطاقة', category: 'Energy & Utilities' },
  { id: 'water', en: 'Water Treatment, Transmission & Distribution', ar: 'معالجة ونقل وتوزيع المياه', category: 'Energy & Utilities' },
  { id: 'energy_storage', en: 'Energy Storage', ar: 'تخزين الطاقة', category: 'Energy & Utilities' },
  
  // Specialized Industries
  { id: 'hospitality', en: 'Hospitality & Tourism', ar: 'الضيافة والسياحة', category: 'Specialized Industries' },
  { id: 'healthcare', en: 'Healthcare', ar: 'الرعاية الصحية', category: 'Specialized Industries' },
  { id: 'education', en: 'Education', ar: 'التعليم', category: 'Specialized Industries' },
  { id: 'retail', en: 'Retail', ar: 'التجزئة', category: 'Specialized Industries' },
  { id: 'industrial', en: 'Industrial Manufacturing', ar: 'التصنيع الصناعي', category: 'Specialized Industries' },
  { id: 'technology', en: 'Technology & IT', ar: 'التكنولوجيا وتقنية المعلومات', category: 'Specialized Industries' },
  { id: 'cultural', en: 'Culture, Sports & Entertainment', ar: 'الثقافة والرياضة والترفيه', category: 'Specialized Industries' },
  { id: 'defense', en: 'Military & Defense', ar: 'الدفاع والعسكرية', category: 'Specialized Industries' },
  
  // Professional Services
  { id: 'engineering', en: 'Engineering', ar: 'الهندسة', category: 'Professional Services' },
  { id: 'architecture', en: 'Architecture', ar: 'العمارة', category: 'Professional Services' },
  { id: 'consulting', en: 'Consulting', ar: 'الاستشارات', category: 'Professional Services' },
  { id: 'project_mgmt', en: 'Project Management', ar: 'إدارة المشاريع', category: 'Professional Services' },
  
  // Specialized Services
  { id: 'lab_test', en: 'Laboratory & Testing', ar: 'المختبرات والاختبارات', category: 'Specialized Services' },
  { id: 'gov_adm', en: 'Governmental Services', ar: 'الخدمات الحكومية', category: 'Specialized Services' },
  { id: 'finance', en: 'Banking & Finance', ar: 'البنوك والتمويل', category: 'Specialized Services' },
  { id: 'marketing', en: 'Marketing', ar: 'التسويق', category: 'Specialized Services' },
  { id: 'software_it', en: 'Software & IT Services', ar: 'البرمجيات وخدمات تقنية المعلومات', category: 'Specialized Services' }
];

// WO-73 — six sectors used by PROJECTS only (not offered in the Tenders, News or
// Companies filters, which have no records carrying them).
export const PROJECT_ONLY_SECTORS = [
  { id: 'public_buildings', en: 'Government & Public Buildings', ar: 'المباني الحكومية والعامة' },
  { id: 'roads', en: 'Roads, Bridges & Tunnels', ar: 'الطرق والجسور والأنفاق' },
  { id: 'rail', en: 'Rail & Metro', ar: 'السكك الحديدية والمترو' },
  { id: 'petrochemicals', en: 'Petrochemicals & Chemicals', ar: 'البتروكيماويات والكيماويات' },
  { id: 'waste', en: 'Waste Management & Recycling', ar: 'إدارة النفايات وإعادة التدوير' },
  { id: 'mining_metals', en: 'Mining & Metals', ar: 'التعدين والمعادن' },
];

// WO-73 — how a PROJECT is classified: by what is being built. One main sector,
// then at most two more, main first. Mirror of backend services/project_sectors.py.
// The 13 service labels (Engineering, Consulting, Banking & Finance…) describe
// the firms that work on projects; they stay for Companies and Tenders only.
export const MAX_PROJECT_SECTORS = 3;
export const PROJECT_SECTOR_GROUPS = [
  { id: 'real_estate', en: 'Real Estate & Buildings', ar: 'العقارات والمباني',
    sectors: ['residential', 'commercial', 'mixed_use', 'hospitality', 'retail', 'healthcare', 'education', 'cultural', 'public_buildings'] },
  { id: 'transport', en: 'Transport', ar: 'النقل',
    sectors: ['transportation', 'roads', 'rail', 'airports', 'maritime', 'logistics'] },
  { id: 'energy', en: 'Energy', ar: 'الطاقة',
    sectors: ['oil_gas', 'petrochemicals', 'power', 'renewable', 'energy_storage'] },
  { id: 'water_environment', en: 'Water & Environment', ar: 'المياه والبيئة',
    sectors: ['water', 'waste'] },
  { id: 'industry_mining', en: 'Industry & Mining', ar: 'الصناعة والتعدين',
    sectors: ['industrial', 'mining_metals', 'defense'] },
  { id: 'digital', en: 'Digital', ar: 'الرقمية',
    sectors: ['datacenters', 'technology'] },
  { id: 'urban_infrastructure', en: 'Urban Infrastructure', ar: 'البنية التحتية الحضرية',
    sectors: ['utilities_infra'] },
];
export const PROJECT_SECTOR_IDS = PROJECT_SECTOR_GROUPS.flatMap(g => g.sectors);
export const SERVICE_INDUSTRY_IDS = [
  'general_construction', 'civil', 'mep', 'fit_out', 'engineering', 'architecture', 'consulting',
  'project_mgmt', 'lab_test', 'gov_adm', 'finance', 'marketing', 'software_it',
];

// Industry categories for grouping
export const INDUSTRY_CATEGORIES = [
  { id: 'Construction', en: 'Construction', ar: 'البناء' },
  { id: 'Real Estate', en: 'Real Estate', ar: 'العقارات' },
  { id: 'Infrastructures', en: 'Infrastructures', ar: 'البنية التحتية' },
  { id: 'Energy & Utilities', en: 'Energy & Utilities', ar: 'الطاقة والمرافق' },
  { id: 'Specialized Industries', en: 'Specialized Industries', ar: 'الصناعات المتخصصة' },
  { id: 'Professional Services', en: 'Professional Services', ar: 'الخدمات المهنية' },
  { id: 'Specialized Services', en: 'Specialized Services', ar: 'الخدمات المتخصصة' }
];

// Helper function to get industry options for filters
export const getIndustryOptions = (language = 'en') => {
  return STANDARD_INDUSTRIES.map(industry => ({
    value: industry.id,
    label: language === 'ar' ? industry.ar : industry.en
  }));
};

// Helper function to get industry options grouped by category
export const getGroupedIndustryOptions = (language = 'en') => {
  const grouped = {};
  INDUSTRY_CATEGORIES.forEach(cat => {
    const options = STANDARD_INDUSTRIES
      .filter(ind => ind.category === cat.id)
      .map(ind => ({
        value: ind.id,
        label: language === 'ar' ? ind.ar : ind.en
      }));
    
    if (options.length > 0) {
      grouped[cat.id] = {
        label: language === 'ar' ? cat.ar : cat.en,
        options
      };
    }
  });
  return grouped;
};

// Helper function to get industry label by ID
// WO-31 — never show a raw code. Company records imported before the list was
// settled use their own codes for the same industries ("civil_works"); they are
// named as their standard twin. Anything still unknown is written as words.
export const INDUSTRY_ALIASES = {
  civil_works: 'civil',
  banking_finance: 'finance',
  commercial_real_estate: 'commercial',
  residential_real_estate: 'residential',
  data_centers: 'datacenters',
  governmental_services: 'gov_adm',
  laboratory_testing: 'lab_test',
  maritime_ports: 'maritime',
  military_defense: 'defense',
  technology_it: 'technology',
  utilities_infrastructure: 'utilities_infra',
  cultural_entertainment: 'cultural',
  media_advertising: 'marketing'
};

// WO-73 — the sectors a project shows, main first: project sectors only, old
// spellings resolved, no repeats, at most `max`.
export const projectSectorsOf = (item, max = MAX_PROJECT_SECTORS) => {
  const raw = item?.sectors?.length ? item.sectors : (item?.sector ? [item.sector] : []);
  const out = [];
  raw.forEach((v) => {
    const id = INDUSTRY_ALIASES[v] || LEGACY_INDUSTRY_MAP[v] || v;
    if (PROJECT_SECTOR_IDS.includes(id) && !out.includes(id)) out.push(id);
  });
  return out.slice(0, max);
};
const EXTRA_INDUSTRY_LABELS = {
  facility_management: { en: 'Facility Management', ar: 'إدارة المرافق' }
};

export const getIndustryLabel = (id, language = 'en') => {
  const industry = STANDARD_INDUSTRIES.find(ind => ind.id === id) || PROJECT_ONLY_SECTORS.find(ind => ind.id === id);
  if (industry) return language === 'ar' ? industry.ar : industry.en;
  if (!id || typeof id !== 'string') return id;
  if (INDUSTRY_ALIASES[id]) return getIndustryLabel(INDUSTRY_ALIASES[id], language);
  const extra = EXTRA_INDUSTRY_LABELS[id];
  if (extra) return language === 'ar' ? extra.ar : extra.en;
  const words = id.replace(/[_-]+/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

// Helper function to get industry category by ID
export const getIndustryCategory = (id) => {
  const industry = STANDARD_INDUSTRIES.find(ind => ind.id === id);
  return industry ? industry.category : null;
};

// Map legacy values to standardized IDs
export const LEGACY_INDUSTRY_MAP = {
  // Legacy mappings for backwards compatibility
  'Construction': 'general_construction',
  'construction': 'general_construction',
  'Infrastructure': 'utilities_infra',
  'infrastructure': 'utilities_infra',
  'Energy': 'power',
  'energy': 'power',
  'Transportation': 'transportation',
  'Technology': 'technology',
  'Real Estate': 'mixed_use',
  'real_estate': 'mixed_use',
  'Commercial': 'commercial',
  'Logistics': 'logistics',
  'Maritime': 'maritime',
  'Renewable': 'renewable',
  'Utilities': 'utilities_infra',
  'utilities': 'utilities_infra',
  'Mixed Use': 'mixed_use',
  'Aviation': 'airports',
  'aviation': 'airports',
  'Tourism': 'hospitality',
  'tourism': 'hospitality',
  'Cultural': 'cultural',
  'Oil & Gas': 'oil_gas',
  'Power Generation': 'power',
  'Water Desalination': 'water',
  'Hospitality': 'hospitality',
  'Retail': 'retail',
  'Engineering': 'engineering',
  'Architecture': 'architecture',
  'Project Management': 'project_mgmt',
  'Urban Planning': 'consulting',
  'MEP': 'mep',
  'Civil Works': 'civil',
  'Fit-out': 'fit_out',
  'Automotive': 'industrial'
};

// Helper to normalize legacy industry values
export const normalizeIndustry = (value) => {
  return LEGACY_INDUSTRY_MAP[value] || value;
};

// Get all unique IDs for validation
export const getAllIndustryIds = () => {
  return STANDARD_INDUSTRIES.map(ind => ind.id);
};

// Check if an industry ID is valid
export const isValidIndustryId = (id) => {
  return STANDARD_INDUSTRIES.some(ind => ind.id === id);
};
